import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import OrderReview from 'public/components/DefaultLayout/OrderReview';
import { FarmProduct } from 'public/context/CartContext';
import { Spinner } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { StyledOrderPage } from './style';
import { useAuth } from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import PublicRoute from 'enums/publicRoutes';

export const OrderPage = () => {
  const [farmProducts, setFarmProducts] = useState<FarmProduct[]>([]);
  const [priceTotal, setPriceTotal] = useState<number>(0);
  let [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');
  const isValidOrderId = !!orderId && /^\d+$/.test(orderId);

  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user !== null && !user?.authenticated) {
      navigate(PublicRoute.LOGIN, { replace: true });
    }
  }, [navigate, user]);

  const { isLoading: orderLoading } = useQueryApiClient({
    request: {
      url: `/api/v2/farm/order/${orderId}`,
      method: 'GET',
    },
    enabled: isValidOrderId,
    onSuccess: (response) => {
      setFarmProducts(response.farmProducts);
      setPriceTotal(response.priceTotal);
    },
  });

  return (
    <StyledOrderPage>
      <div className={'container'}>
        <Spinner spinning={orderLoading}>
          <OrderReview
            priceTotal={priceTotal}
            farmProducts={farmProducts}
            isView={true}
          />
        </Spinner>
      </div>
    </StyledOrderPage>
  );
};
